import { Badge } from '@radix-ui/themes'
import { isLabelExpired, isReturnInProgress, type MaterialReturn } from '../service'

interface ReturnStatusBadgeProps {
  materialReturn: Pick<MaterialReturn, 'received_at' | 'label_expires_on'>
}

export const ReturnStatusBadge = ({ materialReturn }: ReturnStatusBadgeProps) => {
  if (isLabelExpired(materialReturn)) return <Badge color="red">Label expired</Badge>
  if (isReturnInProgress(materialReturn)) return <Badge color="amber">In progress</Badge>
  return <Badge color="green">Received</Badge>
}
